/**Dependencies */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useForm from "../hooks/useForm";
import { Navigation } from "swiper/modules";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import {
  Container,
  Row,
  Col,
  Card,
  Badge,
  Button,
  Form,
} from "react-bootstrap";
import { InformationSection } from "../components/InformationSection";
import { CardsProducts } from "../components/CardsProducts";
import { Swiper, SwiperSlide } from "swiper/react";
import { infoCursos } from "../helpers";
import Swal from "sweetalert2";

/**Styles */
import "../styles/cursos.scss";

/**Images */
import bannerSelectCurso from "../images/banners/banner-select-curso.png";
import bannerContacto from "../images/banners/banner de contacto cursos.png";
import bannerFormulario from "../images/banners/banner Formulario.png";
import bannerProgramas from "../images/banners/Banner-Programas-disponibles.png";
import ofersImg1 from "../images/Curso de idiomas.png";
import ofersImg2 from "../images/Campamentos.png";
import ofersImg3 from "../images/High School.png";
import ofersImg4 from "../images/Universidades & College.png";
import iconBook from "../images/icons/Icono Curso de idiomas.png";
import iconCamping from "../images/icons/Icono campamentos.png";
import iconBag from "../images/icons/Icono High School.png";
import iconCertificate from "../images/icons/Icono Universidades & College.png";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

// Services
import { getEmailText } from "../services/emailService";
import {
  getFiltersBySection,
  getProductsBySection,
} from "../services/adminProductService";

export const Cursos = () => {
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    age: "",
    phone: "",
    time: "",
    date: "",
    country: "",
  };
  const [coursesList, setCoursesList] = useState([]);
  const [cardCourses, setCardCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("All");
  const [filteredData, setFilteredData] = useState(cardCourses);

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
    age: {
      test: (value) => /^\d+$/.test(value) && parseInt(value, 10) >= 0,
      message: "La edad debe ser un número positivo.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const cardsOfers = [
    { img: ofersImg1, title: "Curso de Idiomas", icon: iconBook },
    { img: ofersImg2, title: "Campamentos", icon: iconCamping },
    { img: ofersImg3, title: "High School ", icon: iconBag },
    { img: ofersImg4, title: "Universidades & College", icon: iconCertificate },
  ];

  const location = useLocation();

  useEffect(() => {
    // Verificar si hay un hash en la URL
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await getFiltersBySection("CAMP");
        const responseProducts = await getProductsBySection("CAMP");
        setCoursesList(response);
        setCardCourses(responseProducts);
        setFilteredData(responseProducts);
      } catch (err) {
        console.error("Error al cargar los filtros:", err);
      }
    };
    fetchFilters();
  }, []);

  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre completo: ${formData.fullName} \nNúmero de teléfono: ${formData.phone} \nEmail: ${formData.email} \nEdad: ${formData.age} \nFechas en la que desea estudiar: ${formData.date} \nDuración del curso: ${formData.time} \nPaís deseado: ${formData.country}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };

  /**
   * Handle the change event of the select element and update the selectedCourse state.
   * @param {React.ChangeEvent<HTMLSelectElement>} event The change event.
   */
  const handleSelectChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  /**
   * Filtra los cardCourses según el ID proporcionado y actualiza el estado de filteredData.
   * Si el ID no es "All", filtra los cursos para incluir solo aquellos con un nombre coincidente.
   * De lo contrario, configura filteredData para incluir todos los cardCourses.
   *
   * @param {string} id - The ID used to filter the cardCourses. If 'All', all courses are included.
   */

  const handleFilter = (id) => {
    const element = document.querySelector("#cursos-list");
    if (id !== "All") {
      // Filtrar los datos que coincidan con el ID
      const filtered = cardCourses.filter((item) => item.nombre === id);
      setFilteredData(filtered);
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      // Mostrar todos los datos originales
      setFilteredData(cardCourses);
    }
  };

  const handleSubmitFilter = (event) => {
    event.preventDefault();
    handleFilter(selectedCourse);
  };

  return (
    <div>
      <PrincipalBanner idElemento={6} />

      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="section-title">
            Ahora estudiar en el extrajero, ¡Es más fácil de lo que crees!
          </h1>
          <p className="section-subtitle" style={{ textAlign: "start" }}>
            Te permitirá desarrollar una mentalidad de negocios sin límites, ya
            que al tener contacto con personas de un país diferente, aprenderás
            de la cultura y desarrollarás nuevas habilidades, que en el futuro
            te ayudarán a desenvolverte más fácilmente en un ambiente laboral
            multicultural{" "}
          </p>
        </div>
      </Container>

      <div className="py-5" id="programas-disponibles">
        <img
          src={bannerProgramas}
          alt="Banner"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="section-title mb-5">¿Qué ofrecemos?</h1>
          <Row className="g-4">
            {cardsOfers?.map((info, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="card-ofertas">
                  <div className="card-ofertas__card-image-container">
                    <Card.Img
                      variant="top"
                      src={info?.img}
                      alt={`Imagen ${index + 1}`}
                    />
                    <Badge bg="primary" className="bag-badge">
                      <img
                        src={info?.icon}
                        alt="icono promocion"
                        style={{ width: "17px" }}
                      />
                    </Badge>
                  </div>
                  <Card.Body className="bg-light">
                    <Card.Title className="card-ofertas__text-ofertas">
                      {info?.title}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <div className="bannner-ingles">
        <img
          src={bannerSelectCurso}
          alt="Imagen banner ingles"
          className="bannner-ingles__img-banner"
        />
        <div className="bannner-ingles__form-container">
          <h1 className="text-white mb-5" style={{ fontSize: "30px" }}>
            Elige el destino de tu interés
          </h1>
          <Form onSubmit={handleSubmitFilter}>
            <Form.Group controlId="formSelect">
              <Form.Control
                as="select"
                className="bannner-ingles__form-container__select"
                onChange={handleSelectChange}
              >
                <option value={"All"}>Todos</option>
                {coursesList?.map((course, index) => (
                  <option
                    key={index + 1}
                    onClick={() => handleFilter(course?.nombre)}
                  >
                    {course?.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <br />
            <div className="d-flex justify-content-center">
              <Button
                className="bannner-ingles__form-container__button btn-red"
                type="submit"
                style={{ fontSize: "15px" }}
              >
                Busca tu curso
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <div className="container py-5" id="cursos-list">
        <div className="text-center mb-5">
          <h1 className="" style={{ textAlign: "start" }}>
            Cursos Disponibles
          </h1>
        </div>
        <div className="slider-container carousel-container">
          <div className="custom-prev" id="prev-cursos">
            <IoIosArrowBack />
          </div>
          <Swiper
            navigation={{
              nextEl: "#next-cursos",
              prevEl: "#prev-cursos",
            }}
            modules={[Navigation]}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {filteredData &&
              filteredData?.map((info, index) => (
                <SwiperSlide key={index}>
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    key={index + 1}
                    className="promociones-home d-flex justify-content-center"
                  >
                    <CardsProducts infoCards={info} type={"cursos"} />
                  </Col>
                </SwiperSlide>
              ))}
          </Swiper>
          <div className="custom-next" id="next-cursos">
            <IoIosArrowForward />
          </div>
        </div>
      </div>

      <div>
        <InformationSection title={"¿Cómo reservar?"} arrInfo={infoCursos} />
      </div>

      <div
        className="form-container py-5 container"
        style={{ position: "relative" }}
      >
        <img
          src={bannerFormulario}
          alt="Imagen"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "15px",
          }}
        />
        <div className="form-cursos">
          <h2>
            Llena el siguiente formulario y un asesor de viaje se pondrá en
            contacto contigo para planear un viaje espectacular.
          </h2>
          <br />
          <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
            <Row className="g-4">
              <Col xs={12} md={6}>
                <Form.Group controlId="formNombre">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formCorreo">
                  <Form.Label>Correo Electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formFecha">
                  <Form.Label>Fecha en la que planeas estudiar</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className="input-light"
                    style={{ color: "white" }}
                    min={new Date().toJSON().slice(0, 10)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPais">
                  <Form.Label>Elije el país donde estudiar</Form.Label>
                  <Form.Control
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6}>
                <Form.Group controlId="formTelefono">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    name="phone"
                    onChange={handleChange}
                    value={formData.phone}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formEdad">
                  <Form.Label>Edad</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={2}
                    name="age"
                    onChange={handleChange}
                    value={formData.age}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formDuracion">
                  <Form.Label>¿Cuántas semanas deseas estudiar?</Form.Label>
                  <Form.Control
                    type="text"
                    name="time"
                    onChange={handleChange}
                    value={formData.time}
                    className="input-light"
                    style={{ color: "white" }}
                    required
                  />
                </Form.Group>

                <Button
                  className="btn-white"
                  type="submit"
                  style={{ width: "100%", height: "35px", marginTop: "25px" }}
                >
                  Cotiza
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      <div className="py-5">
        <div style={{ position: "relative", width: "100%", height: "350px" }}>
          <img
            src={bannerContacto}
            alt="Imagen"
            style={{ width: "100%", height: "100%" }}
          />
          <Button className="btn-travel-us blue">
            <FaPhoneAlt /> 777 179 0074
          </Button>
        </div>
      </div>
    </div>
  );
};
